import { IBaseAction, IPromiseParam } from '../base';
import { put, call, takeEvery, takeLatest } from 'redux-saga/effects';
import * as types from './actionTypes.corpus';
import * as _ from 'lodash';
import * as errorSaga from '../errors/saga.errors';
import { CorpusApi } from '../../api/CorpusApi';
import { IGetCorpusDocumentParam, IGetCorpusDocumentsParam, ISearchByCorpusParam, ISelectCorpusDocumentParam } from './actions.corpus';
import getUrlInfo from '../../services/mini/getUrlInfo';
import { getFirstDocument, makeCorpusTree } from '../../views/pages/corpuse/corpusTreeHelpers';
import store from '../../store';

export function* watch() {
    yield takeLatest<IGetCorpusDocumentsParam & IBaseAction>(types.GET_CORPUSE_REQ, getCorpusDocuments);
    yield takeLatest<IGetCorpusDocumentParam & IBaseAction>(types.GET_CORPUSE_DOCUMENT_REQ, getCorpusDocument);
    yield takeLatest<ISearchByCorpusParam & IBaseAction>(types.SEARCH_BY_CORPUSE_REQ, searchByCorpus);
    yield takeLatest<ISelectCorpusDocumentParam & IBaseAction>(types.SELECT_CORPUS_DOCUMENT_REQ, selectCorpusDocument);
    yield takeLatest<ISelectCorpusDocumentParam & IBaseAction>(types.SELECT_CORPUS_DOCUMENT_IN_SEARCH_REQ, selectCorpusDocumentInSearch);
    yield takeLatest(types.CLEAR_CORPUS_SEARCH_REQ, clearCorpusSearch);
}

function getFirstDocumentForSelection(documents) {
    let selectedDocument = null;

    if (documents?.length > 0) {
        const showTree = documents.every(doc => !!doc.url);
        if (showTree) {
            const tree = makeCorpusTree(documents);
            const firtsDoc = getFirstDocument(tree);
            if (firtsDoc) {
                selectedDocument = firtsDoc;
            }
        } else {
            selectedDocument = documents[0];
        }

    }
    return selectedDocument;
}

function* getCorpusDocuments({ corpusLine, corpusId, corpusTitle, resolve, reject }: IGetCorpusDocumentsParam) {
    try {
        let foundCorpus;
        const { scriptName } = getUrlInfo();

        if (corpusLine && !corpusId) {
            const { corpuses } = yield call(CorpusApi.getCorpuses);

            for (let i = 0; i < corpuses.length; i++) {
                const curCorpus = corpuses[i];
                if (+corpusLine === curCorpus.loc.line && curCorpus.loc.file === scriptName) {
                    foundCorpus = curCorpus;
                    break;
                }
            }
        }
        if (corpusId && corpusTitle) {
            foundCorpus = {
                corpusId,
                title: corpusTitle
            };
        }

        if (foundCorpus && foundCorpus.corpusId) {
            const { documents } = yield call(CorpusApi.getCorpuseDocuments, foundCorpus.corpusId);
            const selectedDocument = getFirstDocumentForSelection(documents);

            yield put({
                type: types.GET_CORPUSE_OK,
                corpusId: foundCorpus.corpusId,
                documents: documents,
                title: foundCorpus.title,
                file: foundCorpus.loc?.file || '',
            });
            if (selectedDocument) {
                yield selectCorpusDocument({ document: selectedDocument, corpusId: foundCorpus.corpusId });
            }

            resolve(documents);

        } else {
            resolve([]);
        }
    } catch (error) {
        resolve([]);
        yield errorSaga.putError(error);
    }
}


function* getCorpusDocument({ corpusId, documentId, resolve, reject }: IGetCorpusDocumentParam) {
    try {
        const { content, meta } = yield call(CorpusApi.getCorpusDocument, corpusId, documentId);

        yield put({ type: types.GET_CORPUSE_DOCUMENT_OK, content, meta });

    } catch (error) {
        yield put({ type: types.GET_CORPUSE_DOCUMENT_OK, content: null });
        yield errorSaga.putError(error);
    }
}

function* searchByCorpus({ corpusId, query, question, maxTokens, resolve, reject }: ISearchByCorpusParam) {
    try {
        const { content, meta, documents } = yield call(CorpusApi.searchByCorpus, corpusId, query, question, +maxTokens);

        const mergedContent = [];
        let docsMap = {};

        if (documents?.length) {
            docsMap = Object.fromEntries(documents.map((t) => [t.lineIdx, true]));
        }

        for (let i = 0; i < content?.length; i++) {
            if (docsMap[i]) {
                mergedContent.push(`<span class="alan-search-separator" id="line-${i}"></span>\n`);
            }
            mergedContent.push(content[i]);
        }

        yield put({ type: types.GET_CORPUSE_DOCUMENT_OK, content: mergedContent, meta });
        yield put({
            type: types.SEARCH_BY_CORPUSE_OK,
            corpusSearchQuery: query,
            corpusSearchQustion: question,
            corpusMaxTokens: maxTokens,
            searchedDocuments: documents || []
        });



    } catch (error) {
        yield put({ type: types.SEARCH_BY_CORPUSE_ERR });
        yield errorSaga.putError(error);
    }
}

function* clearCorpusSearch() {
    try {
        const { documents, corpusId, selectedDocumentInSearch } = store.getState().corpus;
        if (selectedDocumentInSearch) {
            yield selectCorpusDocument({ document: selectedDocumentInSearch, corpusId });
        } else {
            const selectedDocument = getFirstDocumentForSelection(documents);
            yield selectCorpusDocument({ document: selectedDocument, corpusId });
        }

        yield put({ type: types.CLEAR_CORPUS_SEARCH_OK });

    } catch (error) {
        yield errorSaga.putError(error);
    }
}


function* selectCorpusDocument({ document, corpusId, resolve, reject }: ISelectCorpusDocumentParam) {
    yield getCorpusDocument({ corpusId, documentId: document.id });
    yield put({ type: types.SELECT_CORPUS_DOCUMENT_OK, selectedDocument: document });
}


function* selectCorpusDocumentInSearch({ document, corpusId, resolve, reject }: ISelectCorpusDocumentParam) {
    yield put({ type: types.SELECT_CORPUS_DOCUMENT_IN_SEARCH_OK, selectedDocument: document });
}

